(function () {
  var PHONE_ICON =
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M6.5 3.5h3l1.2 3.6-1.9 1.4a12.5 12.5 0 0 0 5.7 5.7l1.4-1.9 3.6 1.2v3c0 .8-.7 1.5-1.5 1.5C10.1 17 7 13.9 7 9.5c0-.8.7-1.5 1.5-1.5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
    '</svg>';

  var CHAT_ICON =
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M5 5.5h14a1.5 1.5 0 0 1 1.5 1.5v7A1.5 1.5 0 0 1 18.5 15.5H11l-3.8 2.8c-.5.4-1.2 0-.7-.6L8.2 15.5H5A1.5 1.5 0 0 1 3.5 14V7A1.5 1.5 0 0 1 5 5.5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
    '</svg>';

  var ARROW_ICON =
    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M7 4.5 11.5 9 7 13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function getHelpConfig() {
    var config = window.ciwLaPrescriptionHelp || {};
    return {
      phoneDisplay: config.phoneDisplay || '(917) 708-9300',
      phoneTel: config.phoneTel || '9177089300',
      phoneHours: config.phoneHours || 'Mon–Sat 10am–6pm ET',
      smsTel: config.smsTel || '+16462172426',
      chatSubtitle: config.chatSubtitle || "We're here for you 24/7",
      readHelpImage: config.readHelpImage || '',
      typesHelpImage: config.typesHelpImage || '',
    };
  }

  function getHelpImageHtml(src, alt) {
    if (src) {
      return (
        '<img class="ciw-la-rx-help-drawer__image-photo" src="' +
        src +
        '" alt="' +
        alt +
        '" width="640" height="360" loading="eager" decoding="async">'
      );
    }

    return '<span class="ciw-la-rx-help-drawer__image-label">Prescription example image</span>';
  }

  function getReadHelpImageHtml() {
    var config = getHelpConfig();
    return getHelpImageHtml(config.readHelpImage, 'Sample eyeglasses prescription form');
  }

  function getTypesHelpImageHtml() {
    var config = getHelpConfig();
    return getHelpImageHtml(config.typesHelpImage, 'Eyeglasses and prescription example');
  }

  function getTeamHtml() {
    var config = getHelpConfig();
    return (
      '<div class="ciw-la-rx-help-drawer__team">' +
      '<h3 class="ciw-la-rx-help-drawer__team-title">Need help? Ask our team</h3>' +
      '<div class="ciw-la-rx-help-drawer__team-cards">' +
      '<a class="ciw-la-rx-help-drawer__team-card" href="tel:' +
      config.phoneTel +
      '">' +
      '<span class="ciw-la-rx-help-drawer__team-card-icon">' +
      PHONE_ICON +
      '</span>' +
      '<span class="ciw-la-rx-help-drawer__team-card-text">' +
      '<span class="ciw-la-rx-help-drawer__team-card-title">Call Us: ' +
      config.phoneDisplay +
      '</span>' +
      '<span class="ciw-la-rx-help-drawer__team-card-sub">' +
      config.phoneHours +
      '</span>' +
      '</span>' +
      '<span class="ciw-la-rx-help-drawer__team-card-arrow">' +
      ARROW_ICON +
      '</span>' +
      '</a>' +
      '<a class="ciw-la-rx-help-drawer__team-card" href="sms:' +
      config.smsTel +
      '">' +
      '<span class="ciw-la-rx-help-drawer__team-card-icon">' +
      CHAT_ICON +
      '</span>' +
      '<span class="ciw-la-rx-help-drawer__team-card-text">' +
      '<span class="ciw-la-rx-help-drawer__team-card-title">Start Live Chat</span>' +
      '<span class="ciw-la-rx-help-drawer__team-card-sub">' +
      config.chatSubtitle +
      '</span>' +
      '</span>' +
      '<span class="ciw-la-rx-help-drawer__team-card-arrow">' +
      ARROW_ICON +
      '</span>' +
      '</a>' +
      '</div>' +
      '</div>'
    );
  }

  function getTypesHelpImageBlockHtml() {
    var config = getHelpConfig();
    if (!config.typesHelpImage) {
      return (
        '<div class="ciw-la-rx-help-drawer__image" aria-hidden="true">' +
        getTypesHelpImageHtml() +
        '</div>'
      );
    }

    return (
      '<div class="ciw-la-rx-help-drawer__image ciw-la-rx-help-drawer__image--photo" aria-hidden="true">' +
      getTypesHelpImageHtml() +
      '</div>'
    );
  }

  function buildTypesDrawerHtml() {
    return (
      '<div class="ciw-la-rx-help-drawer ciw-la-rx-help-drawer--types" hidden aria-hidden="true">' +
      '<button type="button" class="ciw-la-rx-help-drawer__backdrop" aria-label="Close prescription types help"></button>' +
      '<div class="ciw-la-rx-help-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="ciw-la-rx-help-title" tabindex="-1">' +
      '<button type="button" class="ciw-la-rx-help-drawer__close" aria-label="Close">&times;</button>' +
      '<div class="ciw-la-rx-help-drawer__scroll">' +
      '<h2 id="ciw-la-rx-help-title" class="ciw-la-rx-help-drawer__title">Prescription types</h2>' +
      '<div class="ciw-la-rx-help-drawer__divider" role="presentation"></div>' +
      getTypesHelpImageBlockHtml() +
      '<section class="ciw-la-rx-help-drawer__section">' +
      '<p class="ciw-la-rx-help-drawer__section-title">Distance <span>(Single vision)</span></p>' +
      '<p class="ciw-la-rx-help-drawer__section-copy">For clear vision far away — driving, TV, sports, and everyday distance. On your prescription, look for a <strong>minus (-)</strong> in the Sphere column.</p>' +
      '</section>' +
      '<section class="ciw-la-rx-help-drawer__section">' +
      '<p class="ciw-la-rx-help-drawer__section-title">Near vision <span>(Reading)</span></p>' +
      '<p class="ciw-la-rx-help-drawer__section-copy">For reading, phone, and computer work up close. Usually a <strong>plus (+)</strong> in the Sphere column. Send us your full prescription, or choose a reading strength if you already know it.</p>' +
      '</section>' +
      '<section class="ciw-la-rx-help-drawer__section">' +
      '<p class="ciw-la-rx-help-drawer__section-title">Multifocal <span>(Distance and reading)</span></p>' +
      '<p class="ciw-la-rx-help-drawer__section-copy">One pair for both far and near — no switching glasses. We offer <strong>progressives</strong> (no visible line) and <strong>bifocals</strong> (with a line).</p>' +
      '</section>' +
      '<section class="ciw-la-rx-help-drawer__section">' +
      '<p class="ciw-la-rx-help-drawer__section-title">Non-prescription <span>(Fashion)</span></p>' +
      '<p class="ciw-la-rx-help-drawer__section-copy">Plano lenses — no correction needed. You want the frame for style, or your eye doctor will fit lenses for you separately.</p>' +
      '</section>' +
      getTeamHtml() +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  function getReadHelpImageBlockHtml() {
    var config = getHelpConfig();
    if (!config.readHelpImage) {
      return '';
    }

    return (
      '<div class="ciw-la-rx-help-drawer__image ciw-la-rx-help-drawer__image--photo">' +
      getReadHelpImageHtml() +
      '</div>'
    );
  }

  function getReadDrawerBodyHtml() {
    return (
      getReadHelpImageBlockHtml() +
      '<section id="ciw-la-rx-read-help-od-os" class="ciw-la-rx-help-drawer__section">' +
      '<p class="ciw-la-rx-help-drawer__section-title">OD &amp; OS</p>' +
      '<p class="ciw-la-rx-help-drawer__section-copy"><strong>OD</strong> is your right eye. <strong>OS</strong> is your left eye. Some papers say RE or LE instead. Copy each number to the right spot on the form.</p>' +
      '</section>' +
      '<section class="ciw-la-rx-help-drawer__section">' +
      '<p class="ciw-la-rx-help-drawer__section-title">Sphere <span>(SPH)</span></p>' +
      '<p class="ciw-la-rx-help-drawer__section-copy">This is the main power for your glasses. A <strong>minus (-)</strong> means far-away things look blurry. A <strong>plus (+)</strong> means close-up things look blurry.</p>' +
      '</section>' +
      '<section class="ciw-la-rx-help-drawer__section">' +
      '<p class="ciw-la-rx-help-drawer__section-title">Cylinder <span>(CYL)</span></p>' +
      '<p class="ciw-la-rx-help-drawer__section-copy">This fixes a special kind of blurry vision. This box is often empty. If it has a number, you need an Axis number too.</p>' +
      '</section>' +
      '<section class="ciw-la-rx-help-drawer__section">' +
      '<p class="ciw-la-rx-help-drawer__section-title">Axis</p>' +
      '<p class="ciw-la-rx-help-drawer__section-copy">A number from 1 to 180. It goes with Cylinder. If Cylinder is empty, leave Axis empty too.</p>' +
      '</section>' +
      '<section class="ciw-la-rx-help-drawer__section">' +
      '<p class="ciw-la-rx-help-drawer__section-title">Add <span>(Near addition)</span></p>' +
      '<p class="ciw-la-rx-help-drawer__section-copy">Only for progressives or bifocals. Extra help for reading up close.</p>' +
      '</section>' +
      '<section id="ciw-la-rx-read-help-pd" class="ciw-la-rx-help-drawer__section">' +
      '<p class="ciw-la-rx-help-drawer__section-title">PD</p>' +
      '<p class="ciw-la-rx-help-drawer__section-copy">The space between your pupils, in millimeters. We need this to center your lenses. If it is not on your paper, we can use 62 for regular glasses or help you find it.</p>' +
      '</section>' +
      '<section id="ciw-la-rx-read-help-2pd" class="ciw-la-rx-help-drawer__section">' +
      '<p class="ciw-la-rx-help-drawer__section-title">2 PD numbers</p>' +
      '<p class="ciw-la-rx-help-drawer__section-copy">Some papers show two PD numbers (like 33/31). The first number is for your left eye. The second is for your right eye. Check the box on the form if you have two numbers.</p>' +
      '</section>' +
      '<section class="ciw-la-rx-help-drawer__section">' +
      '<p class="ciw-la-rx-help-drawer__section-title">Prism</p>' +
      '<p class="ciw-la-rx-help-drawer__section-copy">For when your eyes do not line up right. If your paper has prism, upload a photo. We will fill it in for you.</p>' +
      '</section>' +
      getTeamHtml()
    );
  }

  function syncReadDrawerScroll(drawer, force) {
    var scroll = drawer && drawer.querySelector('.ciw-la-rx-help-drawer__scroll');
    if (!scroll) return;
    if (!force && scroll.dataset.ciwReadDrawerVersion === READ_DRAWER_VERSION) {
      return;
    }
    scroll.innerHTML = getReadDrawerBodyHtml();
    scroll.dataset.ciwReadDrawerVersion = READ_DRAWER_VERSION;
  }

  function buildReadDrawerHtml() {
    return (
      '<div class="ciw-la-rx-help-drawer ciw-la-rx-help-drawer--read" hidden aria-hidden="true">' +
      '<button type="button" class="ciw-la-rx-help-drawer__backdrop" aria-label="Close how to read your prescription help"></button>' +
      '<div class="ciw-la-rx-help-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="ciw-la-rx-read-help-title" tabindex="-1">' +
      '<div class="ciw-la-rx-help-drawer__header">' +
      '<div class="ciw-la-rx-help-drawer__header-row">' +
      '<h2 id="ciw-la-rx-read-help-title" class="ciw-la-rx-help-drawer__title">How to read my prescription</h2>' +
      '<button type="button" class="ciw-la-rx-help-drawer__close" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="ciw-la-rx-help-drawer__divider" role="presentation"></div>' +
      '</div>' +
      '<div class="ciw-la-rx-help-drawer__scroll">' +
      getReadDrawerBodyHtml() +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  var READ_DRAWER_VERSION = '5';

  function scrollReadHelpToSection(drawer, sectionId) {
    if (!drawer || !sectionId) {
      return;
    }

    var scroll = drawer.querySelector('.ciw-la-rx-help-drawer__scroll');
    var section = scroll && scroll.querySelector('#' + sectionId);
    if (!scroll || !section) {
      return;
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        scroll.scrollTop = Math.max(0, section.offsetTop - 12);
      });
    });
  }

  function openReadHelpDrawer(scrollTarget) {
    if (!window.ciwLaHostApi || !window.ciwLaHostApi.isActive()) {
      return;
    }
    if (!document.body.classList.contains('la-modal-open')) {
      return;
    }

    var drawer = ensureReadDrawer(getModal());
    if (!drawer) {
      return;
    }

    drawer.pendingScrollTarget = scrollTarget || '';
    drawer.openDrawer();
  }
  var openDrawers = [];
  var USAGE_STEP_SELECTOR =
    window.ciwLaUsageStepSelector ||
    '.la-choose-prescription-wrapper:not(.la-render-lenses):not(.la-render-options):not(.la-render-review)';

  function getUsageStepWrapper() {
    return document.querySelector(USAGE_STEP_SELECTOR);
  }

  function buildManualReadHelpTrigger() {
    var trigger = document.createElement('div');
    trigger.className = 'ciw-la-rx-help-trigger ciw-la-rx-help-trigger--manual';
    trigger.innerHTML =
      '<button type="button" class="ciw-la-rx-help-trigger__link" data-ciw-la-rx-read-help-open>' +
      '<span class="ciw-la-rx-help-trigger__underline">How to read my prescription</span>' +
      '</button>' +
      '<button type="button" class="ciw-la-rx-help-trigger__icon" data-ciw-la-rx-read-help-open aria-label="How to read my prescription">' +
      '<span aria-hidden="true">?</span>' +
      '</button>';
    return trigger;
  }

  function removeHelpTriggers() {
    document
      .querySelectorAll('.ciw-la-rx-help-trigger:not(.ciw-la-rx-help-trigger--manual)')
      .forEach(function (trigger) {
        trigger.remove();
      });
    document.querySelectorAll('.la-choose-prescription-wrapper').forEach(function (wrapper) {
      delete wrapper.dataset.ciwHelpBound;
    });
  }

  function getModal() {
    return document.querySelector('#lensadvizor-prescription-modal');
  }

  function ensureTeamSection(drawer) {
    var scroll = drawer.querySelector('.ciw-la-rx-help-drawer__scroll');
    if (!scroll) return;

    var team = scroll.querySelector('.ciw-la-rx-help-drawer__team');
    if (!team) {
      scroll.insertAdjacentHTML('beforeend', getTeamHtml());
    } else {
      team.outerHTML = getTeamHtml();
    }
  }

  function ensureTypesDrawerImage(drawer) {
    if (!drawer || !drawer.classList.contains('ciw-la-rx-help-drawer--types')) return;

    var scroll = drawer.querySelector('.ciw-la-rx-help-drawer__scroll');
    if (!scroll) return;

    var imageBlock = scroll.querySelector('.ciw-la-rx-help-drawer__image');
    if (!imageBlock) return;

    var config = getHelpConfig();
    if (!config.typesHelpImage) return;

    imageBlock.classList.add('ciw-la-rx-help-drawer__image--photo');
    imageBlock.innerHTML = getTypesHelpImageHtml();
  }

  function closeAllDrawers() {
    openDrawers.forEach(function (drawer) {
      if (drawer && typeof drawer.closeDrawer === 'function') {
        drawer.closeDrawer();
      }
    });
  }

  function registerOpenDrawer(drawer) {
    if (!drawer || openDrawers.indexOf(drawer) >= 0) {
      return;
    }
    openDrawers.push(drawer);
  }

  function bindDrawerInteractions(drawer, boundKey) {
    if (!drawer || drawer[boundKey]) {
      return drawer;
    }

    drawer[boundKey] = true;
    registerOpenDrawer(drawer);

    var panel = drawer.querySelector('.ciw-la-rx-help-drawer__panel');
    var backdrop = drawer.querySelector('.ciw-la-rx-help-drawer__backdrop');
    var closeBtn = drawer.querySelector('.ciw-la-rx-help-drawer__close');

    function closeDrawer() {
      drawer.setAttribute('hidden', 'hidden');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('is-open');
    }

    function openDrawer() {
      closeAllDrawers();
      if (drawer.classList.contains('ciw-la-rx-help-drawer--read')) {
        syncReadDrawerScroll(drawer);
      } else {
        ensureTypesDrawerImage(drawer);
        ensureTeamSection(drawer);
      }
      drawer.removeAttribute('hidden');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      if (panel) {
        panel.focus();
      }

      if (drawer.classList.contains('ciw-la-rx-help-drawer--read')) {
        if (drawer.pendingScrollTarget) {
          scrollReadHelpToSection(drawer, drawer.pendingScrollTarget);
        } else {
          var scrollEl = drawer.querySelector('.ciw-la-rx-help-drawer__scroll');
          if (scrollEl) {
            scrollEl.scrollTop = 0;
          }
        }
        drawer.pendingScrollTarget = '';
      }
    }

    drawer.openDrawer = openDrawer;
    drawer.closeDrawer = closeDrawer;

    if (backdrop) {
      backdrop.addEventListener('click', closeDrawer);
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    return drawer;
  }

  function ensureTypesDrawer(modal) {
    if (!modal) return null;
    var drawer = modal.querySelector('.ciw-la-rx-help-drawer--types');
    if (!drawer) {
      modal.insertAdjacentHTML('beforeend', buildTypesDrawerHtml());
      drawer = modal.querySelector('.ciw-la-rx-help-drawer--types');
    } else {
      ensureTeamSection(drawer);
    }

    if (!drawer) return null;
    return bindDrawerInteractions(drawer, 'ciwTypesDrawerBound');
  }

  function ensureReadDrawer(modal) {
    if (!modal) return null;
    var drawer = modal.querySelector('.ciw-la-rx-help-drawer--read');
    var needsRebuild = !drawer || !drawer.querySelector('.ciw-la-rx-help-drawer__header');

    if (needsRebuild) {
      if (drawer) {
        drawer.remove();
      }
      modal.insertAdjacentHTML('beforeend', buildReadDrawerHtml());
      drawer = modal.querySelector('.ciw-la-rx-help-drawer--read');
      if (drawer) {
        var scroll = drawer.querySelector('.ciw-la-rx-help-drawer__scroll');
        if (scroll) {
          scroll.dataset.ciwReadDrawerVersion = READ_DRAWER_VERSION;
        }
      }
    } else {
      syncReadDrawerScroll(drawer);
    }

    if (!drawer) return null;
    return bindDrawerInteractions(drawer, 'ciwReadDrawerBound');
  }

  function ensureDrawer(modal) {
    return ensureTypesDrawer(modal);
  }

  function bindOpenTriggers(container, drawer, attrName) {
    if (!container || !drawer || container.dataset[attrName] === '1') return;
    container.dataset[attrName] = '1';

    container.querySelectorAll('[data-ciw-la-rx-help-open]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        drawer.openDrawer();
      });
    });
  }

  function bindReadHelpDelegation() {
    if (document.documentElement.dataset.ciwReadHelpDelegation === '1') {
      return;
    }
    document.documentElement.dataset.ciwReadHelpDelegation = '1';

    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target.closest('[data-ciw-la-rx-read-help-open]');
        if (!btn) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        openReadHelpDrawer(btn.getAttribute('data-ciw-la-rx-read-help-target') || '');
      },
      true
    );
  }

  function bindReadHelpTriggers(container, drawer) {
    if (!container || !drawer || container.dataset.ciwReadHelpBound === '1') return;
    container.dataset.ciwReadHelpBound = '1';
  }

  function syncUsageSubtitleStyles(trigger) {
    if (!trigger || trigger.classList.contains('ciw-la-rx-help-trigger--manual')) return;

    var link = trigger.querySelector('.ciw-la-rx-help-trigger__link');
    if (!link) return;

    link.style.setProperty('color', '#a3a3a3', 'important');
    link.style.setProperty('text-decoration', 'underline', 'important');
    link.style.setProperty('text-underline-offset', '2px', 'important');

    link.querySelectorAll('.ciw-la-rx-help-trigger__underline, la-translate').forEach(function (node) {
      node.style.setProperty('color', '#a3a3a3', 'important');
      node.style.setProperty('-webkit-text-fill-color', '#a3a3a3', 'important');
      node.style.setProperty('text-decoration', 'none', 'important');
    });
  }

  function ensureHelpTrigger(wrapper, drawer) {
    var heading = wrapper.querySelector('.la-wrapper-heading');
    if (!heading) return;

    var laDesc = wrapper.querySelector('.la-step-description');
    if (laDesc) laDesc.setAttribute('hidden', 'hidden');

    var trigger = heading.querySelector('.ciw-la-rx-help-trigger');
    if (!trigger) {
      trigger = document.createElement('div');
      trigger.className = 'ciw-la-rx-help-trigger';
      trigger.innerHTML =
        '<button type="button" class="ciw-la-rx-help-trigger__link" data-ciw-la-rx-help-open>' +
        'Not sure? <span class="ciw-la-rx-help-trigger__underline">Learn more</span>' +
        '</button>' +
        '<button type="button" class="ciw-la-rx-help-trigger__icon" data-ciw-la-rx-help-open aria-label="Learn about prescription types">' +
        '<span aria-hidden="true">?</span>' +
        '</button>';
      heading.appendChild(trigger);
    }

    bindOpenTriggers(trigger, drawer, 'ciwHelpBound');
    syncUsageSubtitleStyles(trigger);
  }

  function ensureManualRxReadHelpTrigger(form, drawer) {
    if (!form || !drawer) return;

    var heading = form.querySelector('.ciw-la-manual-rx-heading');
    if (!heading) return;

    var trigger = heading.querySelector('.ciw-la-rx-help-trigger--manual');
    if (!trigger) {
      trigger = buildManualReadHelpTrigger();
      heading.appendChild(trigger);
    }

    bindReadHelpTriggers(trigger, drawer);
  }

  function updateManualRxReadHelp() {
    if (!window.ciwLaHostApi || !window.ciwLaHostApi.isActive()) return;
    if (!document.body.classList.contains('la-modal-open')) return;

    var form = document.querySelector('#la-prescription-form.ciw-la-manual-rx-form--mobile');
    if (!form || form.classList.contains('ciw-la-contact-rx-form--mobile') || !form.querySelector('.ciw-la-manual-rx-heading')) {
      return;
    }

    var drawer = ensureReadDrawer(getModal());
    if (!drawer) return;
    ensureManualRxReadHelpTrigger(form, drawer);
  }

  function updateLaPrescriptionHelp() {
    if (!window.ciwLaHostApi || !window.ciwLaHostApi.isActive()) return;
    if (!document.body.classList.contains('la-modal-open')) return;

    var wrapper = getUsageStepWrapper();
    if (!wrapper) {
      removeHelpTriggers();
      return;
    }

    var drawer = ensureDrawer(getModal());
    if (!drawer) return;
    ensureHelpTrigger(wrapper, drawer);
  }

  function scheduleUpdate() {
    updateLaPrescriptionHelp();
    updateManualRxReadHelp();
    window.setTimeout(updateLaPrescriptionHelp, 0);
    window.setTimeout(updateManualRxReadHelp, 0);
    window.setTimeout(updateLaPrescriptionHelp, 150);
    window.setTimeout(updateManualRxReadHelp, 150);
    window.setTimeout(updateLaPrescriptionHelp, 400);
    window.setTimeout(updateManualRxReadHelp, 400);
  }

  function bind() {
    bindReadHelpDelegation();

    document.addEventListener('LensAdvizor:selectLensModal:close', function () {
      removeHelpTriggers();
      closeAllDrawers();
    });

    document.addEventListener('LensAdvizor:component:DidMount', scheduleUpdate);
    document.addEventListener('ciw-la-manual-rx:enhanced', scheduleUpdate);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      openDrawers.forEach(function (drawer) {
        if (drawer.classList.contains('is-open') && typeof drawer.closeDrawer === 'function') {
          drawer.closeDrawer();
        }
      });
    });

    document.addEventListener(
      'click',
      function (event) {
        if (
          !event.target.closest(
            'lensadvizor-btn, #la-select-lenses-btn, .la-select-lenses-btn, [class*="la-select-lenses"]'
          )
        ) {
          return;
        }
        scheduleUpdate();
      },
      true
    );

    new MutationObserver(function () {
      if (document.body.classList.contains('la-modal-open')) scheduleUpdate();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    var modalWait = window.setInterval(function () {
      var modal = getModal();
      var body = modal && modal.querySelector('.la-prescription-modal-content-body');
      if (!body) return;
      window.clearInterval(modalWait);
      new MutationObserver(function () {
        updateLaPrescriptionHelp();
        updateManualRxReadHelp();
      }).observe(body, {
        childList: true,
        subtree: true,
      });
    }, 300);
    window.setTimeout(function () {
      window.clearInterval(modalWait);
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
